const facebookIcon = `
<svg width="40px" height="40px" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <circle fill="none" stroke-width="2" cx="20" cy="20" r="19"></circle>
    <path d="M17.334,16.667 L14,16.667 L14,20 L17.334,20 L17.334,30 L22.334,30 L22.334,20 L25.367,20 L25.667,16.667 L22.334,16.667 L22.334,15.278 C22.334,14.478 22.494,14.167 23.264,14.167 L25.667,14.167 L25.667,10 L21.66,10 C18.667,10 17.334,11.32 17.334,13.847 L17.334,16.667 Z" id="Path_7"></path>
</svg>
`

export default facebookIcon
